import styled from '@emotion/styled'
import tokens from '@lacedltd/design-tokens'
import { Typography } from '@lacedltd/laced-components'

export const CancelOrderContainer = styled.section({
  width: '100%',
  background: tokens.color.yeezy[0],
  padding: tokens.spacing[9],

  form: {
    flexDirection: 'column',
    display: 'flex',
    gap: tokens.spacing[6],
    margin: 0,

    select: {
      width: '100%',
      maxWidth: '23.4375rem'
    }
  }
})

export const ConfirmMessage = styled(Typography.Text)({
  margin: 0,
  color: tokens.color.airJordan.p
})

export const CancelProductOverview = styled.div({
  display: 'flex',
  gap: tokens.spacing[5],
  marginBottom: tokens.spacing[5],

  img: {
    width: '7.8125rem'
  }
})

export const CancelProductInfo = styled.div({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',

  span: {
    margin: 0
  }
})

export const SuccessMessage = styled(Typography.Text)({
  a: {
    textDecoration: 'underline'
  }
})
